<template>
  <div class="layout-box">
    <!-- 头部导航 -->
    <div class="header-box">
      <!-- logo -->
      <div class="logo-box">
        <img src="../../public/logo.svg" alt="logo" />
      </div>
      <!-- 菜单 -->
      <div class="menu-box" v-if="!firstLogin">
        <menu-com :menus="menus" />
      </div>
      <div class="right-box">
        <right-content :top-menu="true" :is-mobile="false" theme="light" />
      </div>
    </div>
    <!-- 内容区 -->
    <div class="content-box">
      <router-view :key="key" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MenuCom from './components/MenuCom/index.vue'
import RightContent from '@/components/GlobalHeader/RightContent'
export default {
  components: {
    MenuCom,
    RightContent,
  },
  data() {
    return {
      menus: [],
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: (state) => state.permission.addRouters,
      firstLogin() {
        return this.$route.query.flag === 'first'
      },
    }),
    key() {
      return this.$route.path
    },
  },
  created() {
    const routes = this.mainMenu.find((item) => item.path === '/')
    this.menus = (routes && routes.children) || []
    // console.log(routes)
  },
}
</script>

<style lang="less" scoped>
.layout-box {
  height: max-content;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header-box {
  width: 100%;
  height: 64px;
  min-width: 886px;
  display: inline-flex;
  justify-content: space-between;
  box-shadow: 0 -1px 0 0 #0000000a inset;
  position: fixed;
  top: 0;
  z-index: 899;
  background: #f0f0f0;
}
.content-box {
  padding: 0 24px 24px;

  margin-top: 64px;
  position: relative;
  overflow: auto;
  flex: 1;
  background: #f0f0f0;
}
.logo-box {
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0 18px;
  height: 64px;
  img {
    height: 24px;
  }
}
.menu-box {
  flex: 1;
}
.right-box {
  // float: right;
  // right: 0;
  line-height: 70px;
}
</style>
